import React, { SyntheticEvent, useState } from 'react'

import { TextInput, Dropdown } from 'components'
import { IconClose, IconSearch } from 'components/Icons'
import { useTranslation } from 'react-i18next'
import { STATUS_OPTIONS } from 'helpers/constants/common'
import { useSearchParams } from 'helpers/hooks'
import { findSelected, onEnter } from 'helpers/common'
import type { OptionProps } from 'types'

interface propsCompanySearch {
  isLoading: boolean
}

function CompanySearchAndFilter(props: propsCompanySearch): JSX.Element {
  const { isLoading } = props
  const [searchParams, setSearchParams] = useSearchParams()
  const { t } = useTranslation(['company', 'common'])
  const base = 'f-company-row'
  const q: string = searchParams?.q || ''

  const [search, setSearch] = useState<string>(q)
  const selected =
    findSelected(STATUS_OPTIONS, searchParams?.isActive) || STATUS_OPTIONS[1]

  const handleStatusChange = (status: OptionProps): void => {
    const nextStatus = status.key
    setSearchParams({ isActive: nextStatus, _page: 1 })
  }

  const _handleChange = (e: SyntheticEvent): void => {
    e.preventDefault()

    const target = e.target as HTMLInputElement

    setSearch(target.value)
  }

  const handleClear = (): void => {
    setSearchParams({ q: '', _page: 1 })
    setSearch('')
  }

  const handleSubmit = (): void => {
    setSearchParams({ q: search.trim(), _page: 1 })
  }

  return (
    <div className={`${base}`}>
      <TextInput
        showIcon={isLoading}
        isLoading={isLoading}
        disabled={isLoading}
        placeholder={t('company:search.placeholder')}
        variants='secondary'
        name='search'
        onChange={_handleChange}
        value={search}
        onKeyDown={onEnter(handleSubmit)}
        withIcon={
          q && q === search ? (
            <span className={`${base}__btn-search`} onClick={handleClear}>
              <IconClose variants='sm' />
            </span>
          ) : (
            <span className={`${base}__btn-search`} onClick={handleSubmit}>
              <IconSearch variants='sm' />
            </span>
          )
        }
      />
      <Dropdown
        options={STATUS_OPTIONS}
        variants='secondary'
        selected={selected}
        onChange={(item) => handleStatusChange(item)}
        label='common:status.label'
        placeholder={t('common:header.status.label')}
      />
    </div>
  )
}

export default CompanySearchAndFilter
